<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'ACTUALIZACION ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre Tipo Lista
                        input.form-control.form-control-sm(v-model="parameter.Name", @keypress.enter="sendInfo()") 
                .form-row
                    .col-md-12.col-sm-12
                        label Activar Preguntas
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveQuestions==2" readonly)  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveQuestions==1"  readonly)   ON
                .form-row
                    .col-md-12.col-sm-12(v-if="parameter.ActiveQuestions==1")
                        label Activar Respuesta No Conformidades
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveAnswerNonconformities==2", @click="parameter.ActiveAnswerNonconformities=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveAnswerNonconformities==1" ,@click="parameter.ActiveAnswerNonconformities=2" )   ON  
                .form-row
                    .col-md-12.col-sm-12
                        label Estado
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.Active==2", @click="parameter.Active=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.Active==1" ,@click="parameter.Active=2")   ON
        div(slot='footer')                      
            button.btn.btn-primary(@click="sendInfo()") Guardar
                       
</template>
<script>
import modal from "../../../complementos/modal.vue"
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },
    data(){
        return{ 
            }
    },
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)            
                    this.$emit("sendInfo",this.parameter)
                }         
            },
            validate(){
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.Name=='' || this.parameter.Name==null ){
                    this.$msgbox.show("Ingrese Nombre","Alerta")
                    return false
                } 
                else if(this.parameter.ActiveQuestions=='' || this.parameter.ActiveQuestions==null ){
                    this.$msgbox.show("Selecione  si activa preguntas","Alerta")
                    return false
                }
                else if(this.parameter.ActiveAnswerNonconformities=='' || this.parameter.ActiveAnswerNonconformities==null ){
                    this.$msgbox.show("Selecione si activa respuesta no conformidades","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>